var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSimpleSpinner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    width: 200,
    height: 200,
    style: {
      shapeRendering: "auto",
      display: "block",
      background: "transparent"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#bbbbbb",
    height: 11,
    width: 6,
    ry: 2.64,
    rx: 2.64,
    y: 26.5,
    x: 47
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.8978675645342312s",
    dur: "1.0101010101010102s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(40 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#bbbbbb",
    height: 11,
    width: 6,
    ry: 2.64,
    rx: 2.64,
    y: 26.5,
    x: 47
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.7856341189674523s",
    dur: "1.0101010101010102s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(80 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#bbbbbb",
    height: 11,
    width: 6,
    ry: 2.64,
    rx: 2.64,
    y: 26.5,
    x: 47
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.6734006734006734s",
    dur: "1.0101010101010102s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(120 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#bbbbbb",
    height: 11,
    width: 6,
    ry: 2.64,
    rx: 2.64,
    y: 26.5,
    x: 47
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.5611672278338945s",
    dur: "1.0101010101010102s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(160 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#bbbbbb",
    height: 11,
    width: 6,
    ry: 2.64,
    rx: 2.64,
    y: 26.5,
    x: 47
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.4489337822671156s",
    dur: "1.0101010101010102s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(200 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#bbbbbb",
    height: 11,
    width: 6,
    ry: 2.64,
    rx: 2.64,
    y: 26.5,
    x: 47
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.3367003367003367s",
    dur: "1.0101010101010102s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(240 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#bbbbbb",
    height: 11,
    width: 6,
    ry: 2.64,
    rx: 2.64,
    y: 26.5,
    x: 47
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.2244668911335578s",
    dur: "1.0101010101010102s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(280 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#bbbbbb",
    height: 11,
    width: 6,
    ry: 2.64,
    rx: 2.64,
    y: 26.5,
    x: 47
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.1122334455667789s",
    dur: "1.0101010101010102s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(320 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#bbbbbb",
    height: 11,
    width: 6,
    ry: 2.64,
    rx: 2.64,
    y: 26.5,
    x: 47
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "0s",
    dur: "1.0101010101010102s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", null))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimpleSpinner);
export default __webpack_public_path__ + "static/media/simple_spinner.e8a7c02a0e5a5a55192702d53581d581.svg";
export { ForwardRef as ReactComponent };